import PropTypes from "prop-types";
import React from "react";
import arrowLeft from "../../icons/left-arrow.svg";
import arrowRight from "../../icons/right-arrow.svg";
// prop: style
const CarouselArrow = ({ className, onClick, direction }) => {
  const icon = { right: arrowRight, left: arrowLeft }[direction];
  return (
    <button
      className={`${className} bg-primary flex ${
        direction === "left" && "ltr:flex-row-reverse rtl:flex-row"
      }`}
      onClick={onClick}
      type="button"
    >
      <img className="rtl:transform rtl:scale-x-69" src={icon} alt="arrow" />
    </button>
  );
};

CarouselArrow.propTypes = {
  className: PropTypes.string,
  // color: PropTypes.oneOf(["primary", "secondary", "success", "error"]),
  onClick: PropTypes.func,
  direction: PropTypes.oneOf("right", "left").isRequired,
};

export default CarouselArrow;
